import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes } from 'react-router-dom';
import AppRouter from './Navigation';
import store from './redux/store.js';
import { Provider } from 'react-redux';
import { jwtDecode } from "jwt-decode";
import setAuthToken from './utils/setAuthToken.js';

class App extends React.Component {
  async componentWillMount() {
    try {
      const res = await localStorage.getItem("toutadminlogin");
      if(res) {
        const session = await JSON.parse(res);
        console.log('reclaimed super login',session);
        console.log('we have a session')
        var decoded = jwtDecode(session.access_token)
        console.log('the reclaimed decoded is',decoded)
        setAuthToken(session.access_token)
        store.dispatch({
          type:'SET_USER',
          payload:{
            user:decoded,
            access_token:session.access_token,
            refresh_token:session.refresh_token
          }
        })
      } else {
        console.log('no session!')
      }
    } catch(error) {
      console.log('session refresh error',error)
    }
  }
  render() {
    return (
      <Provider store={store}>
        <AppRouter />
      </Provider>
    );
    }
}




export default App;
